import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useEffect } from 'react';

const CookiePolicyStatic = () => {

    useEffect(() => {
            window.scrollTo(0, 0);
        }, []);

    return (
        <Box sx={{
            p: '1rem',
            backgroundColor: '#DCF1F0'
        }}>
            <Box sx={{
                maxWidth: '85rem',
                margin: 'auto'
            }}>
                <Box sx={(theme) => ({
                    display: 'flex',
                    padding: 0,
                    alignItems: 'center',
                    justifyContent: 'center',
                    [`${theme.breakpoints.down('sm')}`]: {
                        flexDirection: 'column-reverse'
                    }
                })}>
                    <Typography sx={{ flexBasis: '70%' }}>
                        <>
                            <Typography variant='h5' sx={(theme) => ({
                                color: 'text.secondary',
                                fontSize: '2rem',
                                fontWeight: 'bold'
                            })}>
                                Cookie Policy
                            </Typography>
                            <br />
                            <Typography >
                                <ul style={{ "listStyleType": "decimal" }}>
                                    <li>
                                        <Typography variant="h6">Cookie Policy</Typography >
                                        <p> Our website uses cookies to distinguish you from other users of the mediradar.com website (“the Site”). This helps us to provide you with a good experience when you browse our site and also allows us to improve our site. By continuing to browse our site, you are agreeing to our use of cookies.</p>
                                    </li>
                                    <li>
                                        <Typography variant="h6">What is a cookie</Typography>
                                        <p> A cookie is a small file of letters and numbers that we store on your browser or the hard drive of your computer if you agree. Cookies contain information that is transferred to your computer’s hard drive.</p>
                                    </li>
                                    <li>
                                        <Typography variant="h6">How do we use cookies</Typography >
                                        <p> We will use the information collected to make our website more relevant to your interests.</p>
                                        <p> We may also share this information with third parties for this purpose.</p>
                                        <p> We use the following types of cookie:</p>
                                        <p> Essential cookies. These are cookies that are required for the operation of our website</p>
                                        <p> Analytical/performance cookies. They allow us to recognise and count the number of visitors and to see how visitors move around our website when they are using it.</p>
                                        <p> Functionality cookies. These are used to recognise you when you return to our website.</p>
                                        <p> Targeting cookies. These cookies record your visit to our website, the pages you have visited and the links you have followed.</p>
                                        <p> Please note that third parties (including, for example, advertising networks and providers of external services like web traffic analysis services) may also use cookies, over which we have no control. These cookies are likely to be analytical/performance cookies or targeting cookies</p>
                                    </li>
                                    <li>
                                        <Typography variant="h6">Managing cookies</Typography>
                                        <p>You can block cookies by activating the setting on your browser that allows you to refuse the setting of all or some cookies. However, if you use your browser settings to block all cookies (including essential cookies) you may not be able to access all or parts of our site.</p>
                                    </li>
                                </ul>
                            </Typography>
                        </>
                    </Typography>

                </Box>
            </Box>

        </Box>
    );
};

export default CookiePolicyStatic;